@if(status === HarvestActivityReportStatus.Approved){
  <div class="dot-approved"></div>
} @else if(status === HarvestActivityReportStatus.Rejected){
  <div class="dot-rejected"></div>
} @else{
  <div class="dot-pending"></div>
}
